import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { HammerModule } from "@angular/platform-browser";
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from "@angular/router";
import { ConfirmationDialogService } from "@polk_county_public_schools/ngx-pcps-dialogs/confirmation";
import { CountdownDialogService } from "@polk_county_public_schools/ngx-pcps-dialogs/countdown";
import { MessageBoxDialogService } from "@polk_county_public_schools/ngx-pcps-dialogs/messagebox";
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from "ngx-webstorage";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthTokenInterceptor } from "../routes/interceptor";
import { routes } from '../routes/app.routing.module';
import { ScreenSizeService } from "@polk_county_public_schools/ngx-pcps-dialogs/core";
import { AuthenticatedGuard, UnsavedChangesGuard, UnsavedChangesService } from "../routes/routes.guard";
import { SnackBarModule, SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';

export function getBaseUrl(): string {
    return document.getElementsByTagName('base')[0].href;
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
            withViewTransitions()
        ),
        { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(HammerModule),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideAnimationsAsync(),
        AuthenticatedGuard,
        UnsavedChangesGuard,
        UnsavedChangesService,
        // ScreenSizeService is used by ConfirmationDialogService
        ScreenSizeService,
        //need these here because they are used in authService,
        //which can't have it's own providers list
        //and these services are not providedIn: 'root' in their code
        //so need to provide them in root in this file
        ConfirmationDialogService,
        MessageBoxDialogService,
        CountdownDialogService,
        importProvidersFrom(MatNativeDateModule),
        SnackBarModule,
        SnackBarService
    ],
};


